/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelTerminalPaymentBody
 */
export interface CancelTerminalPaymentBody {
    /**
     * 
     * @type {string}
     * @memberof CancelTerminalPaymentBody
     */
    terminalId: string;
}

/**
 * Check if a given object implements the CancelTerminalPaymentBody interface.
 */
export function instanceOfCancelTerminalPaymentBody(value: object): value is CancelTerminalPaymentBody {
    if (!('terminalId' in value) || value['terminalId'] === undefined) return false;
    return true;
}

export function CancelTerminalPaymentBodyFromJSON(json: any): CancelTerminalPaymentBody {
    return CancelTerminalPaymentBodyFromJSONTyped(json, false);
}

export function CancelTerminalPaymentBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelTerminalPaymentBody {
    if (json == null) {
        return json;
    }
    return {
        
        'terminalId': json['terminalId'],
    };
}

export function CancelTerminalPaymentBodyToJSON(json: any): CancelTerminalPaymentBody {
    return CancelTerminalPaymentBodyToJSONTyped(json, false);
}

export function CancelTerminalPaymentBodyToJSONTyped(value?: CancelTerminalPaymentBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'terminalId': value['terminalId'],
    };
}

